import { renderRoutes, matchRoutes } from 'react-router-config'
import routes, { resolveRoute } from '@/routes/routes'
import React, { Suspense, useEffect, useLayoutEffect } from 'react'
import { Switch, useLocation } from 'react-router-dom'
import { checkoutLogin, jumpWhiteList, loginWhiteList, redirectByUrl, getUrlPath, getUrlQuery, setDefaultRefreshUrl, REFRESH_URL, saveTokenToStorage, getStorage, CODE_LOGIN } from '@yuanfudao/metis-unified-login'
import { ProjectConfig } from '@/project-config/index'
import Header from './components/header'
import { useGlobalState } from './store'
import Loading from './components/loading'
import { metisClog } from './metis-clog'
import { useAccount } from '@yuanfudao/metis-standard-data'
import { octopus } from './octopus'

export default function App() {
  const location = useLocation()

  const { updateGlobalState, setIsLogin } = useGlobalState()

  const { accountId, accountPhone } = useAccount()

  useLayoutEffect(() => {
    const initData = async () => {
      try {
        console.log('initData')
        if (ProjectConfig.saveTokenToStorageWhenInitData) {
          const at = getStorage(CODE_LOGIN.ACCESS_TOKEN)
          const rt = getStorage(CODE_LOGIN.REFRESH_TOKEN)
          if (at && rt) {
            saveTokenToStorage(at, rt)
          }
        }
        const curPath = getUrlPath()
        const isWhitePath = loginWhiteList.some((path) => curPath.startsWith(path))
        const isWhiteJumpPath = jumpWhiteList.some((path) => curPath.startsWith(path))
        console.log('await login')
        const login = await checkoutLogin({ jumpLogin: !isWhitePath })
        console.log('login', login)
        if (login) {
          setIsLogin(true)
          if (isWhitePath) {
            return
          }
          // 白名单页面中，包含进入页面清理登录 cookie 的逻辑，因此白名单页不发需要登录态的请求获取教师信息
          updateGlobalState()
          if (getUrlQuery().switchSchool !== '1') {
            // 登录了，已经选了学校，并且不是来切换学校的，直接跳走
            if (!isWhiteJumpPath) {
              redirectByUrl()
            }
          }
        }
      } catch (e) {
        console.warn(e)
      }
    }
    // 代客登录不需要请求全局数据
    if (location.pathname !== resolveRoute({ name: 'designationLogin' }) && location.pathname !== resolveRoute({ name: 'designationStudentLogin' }) && location.pathname !== resolveRoute({ name: 'tokenLogin' })) {
      initData()
    }
    const onUnhandledrejection = (e: PromiseRejectionEvent) => {
      console.warn(e)
      e.preventDefault()
    }
    window.addEventListener('unhandledrejection', onUnhandledrejection)
    return () => {
      window.removeEventListener('unhandledrejection', onUnhandledrejection)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const teacherPath = ['/embed/choose', '/choose']
    if (teacherPath.some((path) => location.pathname.startsWith(path))) {
      setDefaultRefreshUrl(REFRESH_URL.TENANT)
    } else {
      setDefaultRefreshUrl(REFRESH_URL.AUTH)
    }
  }, [location])

  useEffect(() => {
    // 当用户信息能取到时，设置 userId
    if (accountId) {
      metisClog.clog.header.add('userId', String(accountId))
      octopus.setUser({
        id: String(accountId),
        phone: accountPhone ? String(accountPhone) : undefined,
      })
    }
    if (accountPhone) {
      metisClog.clog.header.add('accountPhone', String(accountPhone))
    }
  }, [accountId, accountPhone])

  useEffect(() => {
    const routeMatches = matchRoutes(routes, location.pathname)
    const viewName = (routeMatches?.[routeMatches.length - 1]?.route?.path as string) || location.pathname
    octopus.rum.startView({ name: viewName })
  }, [location.pathname])

  return (
    <div className="contentExcHeader">
      {/* {
        !['/login', '/login/bind'].includes(location.pathname) && <Header />
      } */}
      <Header />
      <Suspense fallback={<Loading />}>
        <Switch location={location}>
          {renderRoutes(routes)}
        </Switch>
      </Suspense>
    </div>
  )
}
